import type { KeyFilter, OnKeyStrokeOptions } from '@vueuse/core'
import { onKeyDown as vueuseOnKeyDown } from '@vueuse/core'
import type { ComputedRef, Ref } from 'vue'

/**
 * Wrapper around { onKeyDown } from '@vueuse/core' to force target Ref | ComputedRef
 * which should eliminate unexpected behavior of the composable
 */
export const onKeyDown = (
  key: KeyFilter,
  handler: (event: KeyboardEvent) => void,
  options: Omit<
    OnKeyStrokeOptions & {
      target: ComputedRef<EventTarget | null | undefined> | Ref<EventTarget | null | undefined>
    },
    'eventName'
  >,
): ReturnType<typeof vueuseOnKeyDown> => vueuseOnKeyDown(key, handler, options)
